import AdminVasps from './AdminVasps'

export default AdminVasps
